import { render, staticRenderFns } from "./StatusInfo.vue?vue&type=template&id=01e2df6e&scoped=true&"
import script from "./StatusInfo.vue?vue&type=script&lang=js&"
export * from "./StatusInfo.vue?vue&type=script&lang=js&"
import style0 from "./StatusInfo.vue?vue&type=style&index=0&id=01e2df6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e2df6e",
  null
  
)

export default component.exports